'use strict';function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const CalendarDay=require('pulsar-utils/dist-es6/time/calendarDay');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const SocketResponse=require('../../../dist-es6/client/dtos/socketResponse');

const MaximumCacheDurationInMs=timespan.fromMinutes(5).totalMilliseconds();let

PersonalIncidentsService=function(_BaseService){_inherits(PersonalIncidentsService,_BaseService);
function PersonalIncidentsService(socketService,dateService){_classCallCheck(this,PersonalIncidentsService);var _this=_possibleConstructorReturn(this,
_BaseService.call(this));
_this._socketService=socketService;
_this._dateService=dateService;

_this.reset();return _this;
}PersonalIncidentsService.prototype.

reset=function reset(){
this._cachedIncidentsAndDayOfLastPurgedIncidentByPersonId={};
this._lastIncidentUnixFetchTimeByPersonId={};

this._resetIncidentTypesCache();
};PersonalIncidentsService.prototype.

getIncidentTypes=function(){var ref=_asyncToGenerator(function*(){
const currentUnixFetchTime=this._dateService.now().getTime();
if(_.exists(this._cachedIncidentTypes)){
if(currentUnixFetchTime-this._lastIncidentTypesUnixFetchTime<=MaximumCacheDurationInMs){
return this._cachedIncidentTypes;
}else{
this.reset();
}
}

const incidentTypesResponse=yield this._socketService.sendAndWaitForResponse('GetIncidentTypes',void 0,{
timeoutInSeconds:3000,
retryOptions:{
retries:5,
maxTimeout:10000},

throwOnUnexpectedError:!0});


if(!SocketResponse.succeeded(incidentTypesResponse)){
throw new Error(`Error getting incident types: ${JSON.stringify(incidentTypesResponse)}`);
}

const incidentTypes=incidentTypesResponse.body;

this._cachedIncidentTypes={
incidentTypes:incidentTypes,
incidentTypesByCode:_.keyBy(incidentTypes,'code')};

this._lastIncidentTypesUnixFetchTime=currentUnixFetchTime;

return this._cachedIncidentTypes;
});function getIncidentTypes(){return ref.apply(this,arguments)}return getIncidentTypes}();PersonalIncidentsService.prototype.

_resetIncidentTypesCache=function _resetIncidentTypesCache(){
this._cachedIncidentTypes=null;
this._lastIncidentTypesUnixFetchTime=null;
};PersonalIncidentsService.prototype.

getAllIncidentsFor=function(){var ref=_asyncToGenerator(function*(personId){
_.ensureInstanceOf('string',personId);

let{incidentTypes:incidentTypes,incidentTypesByCode:incidentTypesByCode}=yield this.getIncidentTypes();
if(incidentTypes.length===0){
return{
incidentTypes:[],
incidents:[],
dayOfLastPurgedIncident:null};

}

let incidents;
let dayOfLastPurgedIncident;
const currentUnixFetchTime=this._dateService.now().getTime();
if(_.exists(this._cachedIncidentsAndDayOfLastPurgedIncidentByPersonId[personId])&&
currentUnixFetchTime-this._lastIncidentUnixFetchTimeByPersonId[personId]<=MaximumCacheDurationInMs){
incidents=this._cachedIncidentsAndDayOfLastPurgedIncidentByPersonId[personId].incidents;
dayOfLastPurgedIncident=this._cachedIncidentsAndDayOfLastPurgedIncidentByPersonId[personId].dayOfLastPurgedIncident;
}else{
const incidentsResponse=yield this._socketService.sendAndWaitForResponse('GetIncidents',{personId:personId});
if(!SocketResponse.succeeded(incidentsResponse)){
throw new Error(`Error getting incidents: ${JSON.stringify(incidentsResponse)}`);
}

incidents=incidentsResponse.body.incidents;
dayOfLastPurgedIncident=_.exists(incidentsResponse.body.dayOfLastPurgedIncident)?
new CalendarDay(incidentsResponse.body.dayOfLastPurgedIncident):
null;

const numIncidents=incidents.length;
for(var i=0;i<numIncidents;i++){
if(!_.exists(incidentTypesByCode[incidents[i].code])){
this._resetIncidentTypesCache();
const regottenIncidentTypeInfo=yield this.getIncidentTypes();
incidentTypes=regottenIncidentTypeInfo.incidentTypes;
incidentTypesByCode=regottenIncidentTypeInfo.incidentTypesByCode;
}
incidents[i].time=new Date(incidents[i].time);
incidents[i].description=incidentTypesByCode[incidents[i].code].description;
}

this._cachedIncidentsAndDayOfLastPurgedIncidentByPersonId[personId]={incidents:incidents,dayOfLastPurgedIncident:dayOfLastPurgedIncident};
this._lastIncidentUnixFetchTimeByPersonId[personId]=currentUnixFetchTime;
}

return{
incidentTypes:incidentTypes,
incidents:incidents,
dayOfLastPurgedIncident:dayOfLastPurgedIncident};

});function getAllIncidentsFor(personId){return ref.apply(this,arguments)}return getAllIncidentsFor}();return PersonalIncidentsService}(BaseService);


module.exports=PersonalIncidentsService;
//# sourceMappingURL=personalIncidentsService.js.map
